import { Field } from 'react-final-form';

import { Select } from '@change/ds-forms';

import { translationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useFormI18n } from 'src/app/shared/form/hooks';
import { requiredValidator } from 'src/app/shared/form/validators';

import type { FormValues, SubCategory } from '../../shared/types';

import { useSubCategoryField } from './hooks/useSubCategoryField';

const validator = requiredValidator<SubCategory>({
	i18n: { key: translationKey('corgi.policy_abuse.generic.errors.sub_category_required') },
});

export const SubCategoryField: React.FC = () => {
	const { translate } = useI18n();
	const { getErrorMessage } = useFormI18n();

	const {
		data: { subCategories },
		actions: { getLabel },
	} = useSubCategoryField();

	if (subCategories.length === 0) return null;

	const subCategoryItems = [
		{ id: '', name: '', label: translate('corgi.policy_abuse.generic.sub_category.prompt') },
		...subCategories.map((subCategory) => ({ id: subCategory, name: subCategory, label: getLabel(subCategory) })),
	];

	return (
		<div>
			<Field<FormValues['subCategory']> name="subCategory" validate={validator}>
				{({ input, meta }) => (
					<Select
						className="[&_button_span]:text-typography-weak"
						name={input.name}
						selectedKey={input.value}
						onSelectionChange={input.onChange}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						errorMessage={meta.touched && getErrorMessage(meta.error)}
						data-testid="reportAbuse-subCategory-select"
						data-qa="reportAbuse-subCategory-select"
						label={translate('corgi.policy_abuse.generic.sub_category.label')}
						items={subCategoryItems}
						isInvalid={meta.touched && !!meta.error}
					/>
				)}
			</Field>
		</div>
	);
};
